import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MiniCalendar = ({ currentDate, selectedDate, onDateSelect }) => {
  const today = new Date();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  const startDate = new Date(firstDayOfMonth);
  startDate?.setDate(startDate?.getDate() - firstDayOfMonth?.getDay());

  const navigateMonth = (direction) => {
    const newDate = new Date(currentDate);
    newDate?.setMonth(newDate?.getMonth() + (direction === 'next' ? 1 : -1));
    onDateSelect(newDate);
  };

  const generateCalendarDays = () => {
    const days = [];
    const current = new Date(startDate);
    
    for (let i = 0; i < 42; i++) {
      days?.push(new Date(current));
      current?.setDate(current?.getDate() + 1);
    }
    
    return days;
  };

  const calendarDays = generateCalendarDays();
  const weekDays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  const isToday = (date) => {
    return date?.toDateString() === today?.toDateString();
  };

  const isSelected = (date) => {
    return selectedDate && date?.toDateString() === selectedDate?.toDateString();
  };

  const isCurrentMonth = (date) => {
    return date?.getMonth() === currentDate?.getMonth();
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      {/* Mini Calendar Header */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-foreground">
          {currentDate?.toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
        </h3>
        <div className="flex items-center space-x-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigateMonth('prev')}
            className="h-6 w-6"
          >
            <Icon name="ChevronLeft" size={14} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigateMonth('next')}
            className="h-6 w-6"
          >
            <Icon name="ChevronRight" size={14} />
          </Button>
        </div>
      </div>
      {/* Week Days Header */}
      <div className="grid grid-cols-7 gap-1 mb-2">
        {weekDays?.map((day) => (
          <div key={day} className="text-xs text-muted-foreground text-center py-1">
            {day}
          </div>
        ))}
      </div>
      {/* Calendar Grid */}
      <div className="grid grid-cols-7 gap-1">
        {calendarDays?.map((date, index) => (
          <Button
            key={index}
            variant="ghost"
            onClick={() => onDateSelect(date)}
            className={`
              h-8 w-8 p-0 text-xs
              ${!isCurrentMonth(date) ? 'text-muted-foreground opacity-50' : ''}
              ${isToday(date) ? 'bg-primary text-primary-foreground' : ''}
              ${isSelected(date) ? 'bg-accent text-accent-foreground' : ''}
            `}
          >
            {date?.getDate()}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default MiniCalendar;